export const progressFromEvent = (event: ProgressEvent<XMLHttpRequestEventTarget>) => {
  if (event.lengthComputable) {
    return Math.floor((event.loaded / event.total) * 100);
  }

  return 0;
};
